import http from "@/api/http.js";

export function getStockComparison(params) {
  return http.get("/warehouse/stock_compare", { params }).then(res => res.data);
}

export function triggerInfoautoSync(departamentoId) {
  console.log("Triggering Infoauto sync for departamento", departamentoId);
  return http
    .get("/warehouse/stock_sync", {
      params: { departamento_id: departamentoId }
    })
    .then(res => res.data);
}

export function triggerInitialLoad(departamentoId) {
  return http
    .post("/warehouse/stock_initial_load", { departamento_id: departamentoId })
    .then(res => res.data);
}

export function getSyncProgress(departamentoId) {
  return http
    .get("/warehouse/sync_progress", { params: { departamento_id: departamentoId } })
    .then(res => res.data);
}

export function submitDiagnosticAdjustments(data) {
  return http.post("/warehouse/stock_adjust", data).then(res => res.data);
}
